import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export const V11ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const isDark =
    theme === 'dark' ||
    (theme === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  const handleToggle = () => {
    const htmlElement = document.documentElement;
    htmlElement.classList.add('theme-transition');

    setTheme(isDark ? 'light' : 'dark');

    setTimeout(() => {
      htmlElement.classList.remove('theme-transition');
    }, 300);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label="Toggle theme"
      onClick={handleToggle}
      className={[
        'relative inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        isDark
          ? 'bg-zinc-800'
          : 'bg-zinc-200',
      ].join(' ')}
    >
      {/* Icon on the track (opposite side of the thumb) */}
      <span
        className={[
          'absolute flex items-center justify-center transition-opacity duration-300',
          isDark ? 'right-1.5 opacity-100' : 'right-1.5 opacity-0',
        ].join(' ')}
        aria-hidden="true"
      >
        <Moon className="h-3.5 w-3.5 text-zinc-400" />
      </span>
      <span
        className={[
          'absolute flex items-center justify-center transition-opacity duration-300',
          isDark ? 'left-1.5 opacity-0' : 'left-1.5 opacity-100',
        ].join(' ')}
        aria-hidden="true"
      >
        <Sun className="h-3.5 w-3.5 text-zinc-500" />
      </span>

      {/* Sliding thumb */}
      <span
        className={[
          'pointer-events-none inline-block h-5 w-5 rounded-full shadow-md ring-0 transition-transform duration-300',
          isDark
            ? 'translate-x-1 bg-white'
            : 'translate-x-8 bg-v11-accent',
        ].join(' ')}
      />
      <span className="sr-only">Toggle theme</span>
    </button>
  );
};
